import { useEffect, useState } from "react"
import { loadPageData, bannerData, conditionData } from "./service"
import { getCookieDF, setSessionStorageDF, getSessionStorageDF } from "@/utils"

/** 数据加载 */
export const useLoadData = (params: any) => {
  const [loading, setLoading] = useState(false)
  const [banner, setBanner] = useState([])
  const [flag, setFlag] = useState<boolean>(true);
  const [data, setData] = useState<any>({})
  const [condition, setCondition] = useState<any>({})
  const [hasMore, setHasMore] = useState(false)
  const [pageNo, setPageNo] = useState<any>(1)

  const saveData = () => {
    setSessionStorageDF('HOME_DATA', JSON.stringify({
      curTopic: params?.curTopic,
      data: data,
      banner: banner,
      condition: condition,
      sortType: params?.sortType,
      departureCityIdList: params?.departureCityIdList,
      departureInfoList: params?.departureInfoList,
      tagIdList: params?.tagIdList,
      tagInfoList: params?.tagInfoList,
    }))
  }

  const sessionData = getSessionStorageDF('HOME_DATA')

  useEffect(() => {
    const ele = document.getElementById('g-content');
    const handleScroll = () => {
      setSessionStorageDF('scrollTop', JSON.stringify(ele?.scrollTop || 0))
    }
    ele?.addEventListener('scroll', handleScroll)
    
    if (sessionData && JSON.parse(sessionData)?.curTopic === params?.curTopic) {
      const { data, banner, condition } = JSON.parse(sessionData)
      setData(data)
      setBanner(banner)
      setCondition(condition)
      setPageNo(data.pageNo)
      setHasMore(data?.listObj?.length < data?.total)
      setFlag(false)
      sessionStorage.removeItem('HOME_DATA')
      setTimeout(() => {
        if (ele) ele.scrollTop = JSON.parse(getSessionStorageDF('scrollTop') || '0');
      }, 800)
      return
    }
    getBanner()
    return () => {
      ele?.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    if (sessionData && JSON.parse(sessionData)?.curTopic === params?.curTopic) return;
    queryCondition(params)
  }, [params.curTopic])

  useEffect(() => {
    if (sessionData && JSON.parse(sessionData)?.curTopic === params?.curTopic) return;
    loadData(params)
  }, [params])

  const loadData = (params: any) => {
    setLoading(true)
    loadPageData({...params, pageNo: 1, pageSize: 10}).then((res: any) => {
      // console.log(res, 'res213');
      setData(res.Data || [])
      setFlag(false)
      setPageNo(1);
      if (res.Data?.listObj?.length >= res.Data?.total) {
        setHasMore(false)
      } else {
        setHasMore(true)
      }
      setLoading(false)
    })
  }

  const loadMoreData = async (params: any) => {
    setHasMore(false)
    const {Data} = await loadPageData({...params, pageNo: pageNo + 1, pageSize: 10})
    setPageNo(pageNo + 1)
    //@ts-ignore
    const list = [...data.listObj, ...(Data?.listObj || [])]
    
    setData({
      ...Data || {},
      listObj: list
    })
    console.log(list?.length, Data?.total, '231');
    
    //@ts-ignore
    if (list?.length < Data?.total) {
      setHasMore(true)
    }
  }

  const getBanner = () => {
    setLoading(true)
    bannerData({
      channelId: 4,
      cityId: params?.cityId || getCookieDF('city'),
      type: 2,
    }).then((res: any) => {
      setLoading(false)
      setBanner(res.Data || [])
    })
  }

  const queryCondition = (params: any) => {
    setLoading(true)
    conditionData({
      businessType: params?.curTopic || 1,
      cityId: params?.cityId || getCookieDF('city'),
    }).then((res: any) => {
      setLoading(false)
      setCondition(res.Data || [])
    })
  }
// console.log(data, 'data23332342');

  return {
    flag,
    setFlag,
    saveData,
    setPageNo,
    data,
    loading,
    banner,
    condition,
    loadData,
    queryCondition,
    hasMore,
    loadMoreData
  }
}
